<!-- <div class="main-body app sidebar-mini" [ngClass]="mainSidebarOpen"> -->
    <div class="horizontalMenucontainer">
        <!-- <app-switcher></app-switcher> -->
        <!-- Page -->
        <div class="page">
            <!-- // header -->
            <app-header-one></app-header-one>
            <!-- main-sidemenu -->
            <app-sidemenu appHoverEffectSidebar></app-sidemenu>
            <!-- main-sidemenu -->
    
            <!-- main-content -->
            <div class="main-content app-content">
    
                <!-- main-header -->
                <!-- <div class="jumps-prevent" style="padding-top: 63px;"></div> -->
                <!-- /main-header -->
    
                <!-- container -->
                <div class="main-container container-fluid" (click)="clickOnBody()">
                    <router-outlet>
                        <app-loader></app-loader>
                    </router-outlet>
                </div>
                <!-- /Container -->
            </div>
            <!-- /main-content -->
    
            <!-- Sidebar-right-->
            <app-notification-sidebar></app-notification-sidebar>
            <!--/Sidebar-right-->
    
            <!-- Footer opened -->
            <!-- Footer closed -->
            
        </div>
        <!-- End Page -->
        <app-footer></app-footer>
    </div>
    <!-- </div> -->